/**
 * Order helpers — match template section.position / field.position
 * as returned in catalog (backend orders by position from latest supporting version).
 *
 * Catalog shape (from GET /report/project-templates):
 * {
 *   [templateName]: {
 *     latestVersion,
 *     templateType, portfolioType, odooModel,
 *     sections: { [sectionName]: string[] },
 *     sectionLatestVersions: { [sectionName]: number },
 *     fieldLatestVersions: { [sectionName]: { [fieldName]: number } },
 *     fieldMeta: { [sectionName]: { [fieldName]: { fieldType, allowPhotos } } },
 *   }
 * }
 */

export const getCatalogSectionNames = (catalog, templateName) =>
	Object.keys(catalog?.[templateName]?.sections || {});

export const getCatalogFieldNames = (catalog, templateName, sectionName) => [
	...(catalog?.[templateName]?.sections?.[sectionName] || []),
];

export const getTemplateDetails = (catalog, templateName) => {
	const entry = catalog?.[templateName] || {};
	return {
		templateType: entry.templateType || "",
		portfolioType: entry.portfolioType || "",
		odooModel: entry.odooModel || "",
	};
};

export const getTemplateLatestVersion = (catalog, templateName) => {
	const v = catalog?.[templateName]?.latestVersion;
	return v == null || Number.isNaN(Number(v)) ? null : Number(v);
};

export const getSectionLatestVersion = (catalog, templateName, sectionName) => {
	const v = catalog?.[templateName]?.sectionLatestVersions?.[sectionName];
	return v == null || Number.isNaN(Number(v)) ? null : Number(v);
};

export const getFieldMeta = (catalog, templateName, sectionName, fieldName) =>
	catalog?.[templateName]?.fieldMeta?.[sectionName]?.[fieldName] || null;

export const fieldAllowsPhotos = (catalog, templateName, sectionName, fieldName) => {
	const meta = getFieldMeta(catalog, templateName, sectionName, fieldName);
	if (!meta) return false;
	if (String(meta.fieldType).toLowerCase() === "photos") return true;
	return meta.allowPhotos === true;
};

export const getFieldLatestVersion = (catalog, templateName, sectionName, fieldName) => {
	const v = catalog?.[templateName]?.fieldLatestVersions?.[sectionName]?.[fieldName];
	return v == null || Number.isNaN(Number(v)) ? null : Number(v);
};

/** Sort names by their index in the catalog order list. Unknown names go last. */
export const sortByCatalogOrder = (names, catalogOrder) => {
	const index = new Map(catalogOrder.map((name, i) => [name, i]));
	return [...names].sort((a, b) => {
		const ai = index.has(a) ? index.get(a) : Number.MAX_SAFE_INTEGER;
		const bi = index.has(b) ? index.get(b) : Number.MAX_SAFE_INTEGER;
		if (ai !== bi) return ai - bi;
		return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
	});
};
